<template lang="">
	<ParentGraph
		:title="$t('formation.graphText')"
		:show="errorImage"
	>
		<div
			class="position-relative"
			v-if="!$siteconf.hideImages?.application"
		>
			<img
				v-if="errorImage"
				alt="white background"
				src="/s/images/Calque_8.png"
				class="position-absolute mt-5"
			>
			<img
				alt="education"
				class="position-relative"
				:src="imageSrc"
				ref="Image"
			>
		</div>
	</ParentGraph>
</template>
<script>
import { imageErrorHandling} from "@/../public/js/imageErrorHandling"
export default {
	mixins: [imageErrorHandling],

	data() {
		return {
			errorImage: false,
			imageSrc: "/c/images/education",
			fallbackImageSrc: "/s/images/formations.png"
		};
	},
	mounted() {
		// Check the image dimensions on mount
		this.preloadImage(this.imageSrc, this.fallbackImageSrc);
	}
	};

</script>